var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"mb10",attrs:{"shadow":"never"}}),_c('el-card',{attrs:{"shadow":"never"}},[_vm._v(" 列表 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }